/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import {
  TransferGuidelines,
  PaymentDepositDetails,
  BankDepositDetails
} from "./deposit-funds";

export {
  TransferGuidelines,
  PaymentDepositDetails,
  BankDepositDetails
};
